import { Box } from "@mui/material";
import Spinner from "./Spinner";

// updated
export default function FullScreenSpinner() {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            }}
        >
            <Spinner />
        </Box>
    );
}
